<!-- <dashboardnav> -->
    <cradua-correspondenceactionparty
    [correspondenceactionpartys]="correspondenceactionpartys$ | async"
    [correspondenceteam]="correspondenceteam$ | async"
    [correspondencestaff]="correspondencestaff$ | async"


    (correspondenceactionparty)="onSubmitCorrespondenceActionParty($event)"
    (deleteCorrespondenceActionPartyEvent)="onDeleteCorrespondenceActionParty($event)"
    *ngIf="
    !(isLoadingCorrespondenceActionParty$ | async ) &&
    !(isLoadingCorrespondenceTeam$ | async ) &&
    !(isLoadingCorrespondenceStaff$ | async )
    "
    >
  </cradua-correspondenceactionparty>

    <mrsoftapps-epims-reference-spinner
    *ngIf="
  (isLoadingCorrespondenceActionParty$ | async ) ||
  (isLoadingCorrespondenceTeam$ | async )||
  (isLoadingCorrespondenceStaff$ | async )
  "
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
